module.exports = __webpack_public_path__ + "static/media/flexible-premium-photo-product.21e5d25f.jpg";